var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("ChallengeAndLeagueSelectorTest")]),_c('h1',[_vm._v(" Test "),_c('ChallengeAndLeagueSelector',{staticClass:"d-inline-flex",model:{value:(_vm.selectedLeague),callback:function ($$v) {_vm.selectedLeague=$$v},expression:"selectedLeague"}})],1),_c('p',[_vm._v("Some text for testing")])])
}
var staticRenderFns = []

export { render, staticRenderFns }